module.exports = __webpack_public_path__ + "static/img/lp3.6063149.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/img/lp3.png
// module id = Mw4r
// module chunks = 1